import { createFileRoute } from '@tanstack/react-router';
import { PackagesScreen } from '../../../features/settings/packages-screen';

/** Catalogul de pachete. Ecran propriu — pachetul are preț, deci nu e un nomenclator. */
export const Route = createFileRoute('/_authenticated/setari/pachete')({
  component: PackagesScreen,
});
